<template>
  <button :disabled="loading" :style="[loading ? {'opacity': '.5'} : '']" v-on:click="onClick()">
    <slot></slot>
    <div class="module-description-tooltip">{{text}}</div>
  </button>
</template>



<script>
export default {
  props: ["loading", "text"],
  data() {
    return {};
  },
  methods: {
    onClick() {
      this.$emit("click");
    }
  },
  created() {}
};
</script>
